import useApplicantAssessmentCounters from '../../AiSearch/api/useApplicantAssessmentCounters';
import Dialogs from '../../components/dialogs/Dialogs';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';

function CandidateOverviewDialogs() {
    const { assessmentName, loadPageAsync } = useCandidatesOverviewContext();
    const { mutate: mutateApplicantAssessmentCounters } = useApplicantAssessmentCounters();

    const handleAssessmentReset = () => {
        loadPageAsync();
        mutateApplicantAssessmentCounters();
    };

    return <Dialogs assessmentName={assessmentName} onAssessmentReset={handleAssessmentReset} />;
}

export default CandidateOverviewDialogs;
